/**
 * GELD Module Seeds — Fase 0 TGL Split
 *
 * Created: 17 maart 2026 (Fase 0 stap 0.9)
 * Activated: 18 maart 2026 (Fase 0 activation batch)
 *
 * All 15 GELD seeds local (batch 1-8, s23-s30).
 * Replaces the GELD portion of TGL/index.ts.
 *
 * See docs/PROJECT_STATUS_AND_ROADMAP.md for project status.
 */

import geldTellen from './TGL-GELD-TELLEN.json';
import geldTellenTF from './TGL-GELD-TELLEN-TF.json';
import geldMaak from './TGL-GELD-MAAK.json';
import geldTerug from './TGL-GELD-TERUG.json';
import geldWissel from './TGL-GELD-WISSEL.json';
import geldWisselen from './TGL-GELD-WISSELEN.json';
import geldKomma from './TGL-GELD-KOMMA.json';
import geldBoodschappen from './TGL-GELD-BOODSCHAPPEN.json';
import geldKoopjes from './TGL-GELD-KOOPJES.json';
import geldBudget from './TGL-GELD-BUDGET.json';
import geldKorting from './TGL-GELD-KORTING.json';
import geldPrijsPer from './TGL-GELD-PRIJS-PER.json';
import geldSparen from './TGL-GELD-SPAREN.json';
import geldBtw from './TGL-GELD-BTW.json';
import geldTerugrekenen from './TGL-GELD-TERUGREKENEN.json';
import geldRenteProc from './TGL-GELD-RENTE-PROC.json';
const GELD_FAMILY_SEEDS = [
// === Skill: geld_basis (groep 6) ===
{
  file: 'src/content/seeds/GELD/TGL-GELD-TELLEN.json',
  data: geldTellen
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-TELLEN-TF.json',
  data: geldTellenTF
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-MAAK.json',
  data: geldMaak
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-TERUG.json',
  data: geldTerug
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-WISSEL.json',
  data: geldWissel
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-WISSELEN.json',
  data: geldWisselen
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-KOMMA.json',
  data: geldKomma
},
// === Skill: geld_toegepast (groep 7-8) ===
{
  file: 'src/content/seeds/GELD/TGL-GELD-BOODSCHAPPEN.json',
  data: geldBoodschappen
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-KOOPJES.json',
  data: geldKoopjes
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-BUDGET.json',
  data: geldBudget
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-KORTING.json',
  data: geldKorting
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-PRIJS-PER.json',
  data: geldPrijsPer
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-SPAREN.json',
  data: geldSparen
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-BTW.json',
  data: geldBtw
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-TERUGREKENEN.json',
  data: geldTerugrekenen
}, {
  file: 'src/content/seeds/GELD/TGL-GELD-RENTE-PROC.json',
  data: geldRenteProc
}] as const;
const allQuestions = GELD_FAMILY_SEEDS.flatMap(({
  file,
  data
}) => data.questions.map(question => ({
  ...question,
  __sourceFile: file
})));
export default {
  module: 'Geld',
  moduleCode: 'GELD',
  version: '1.0-standalone',
  taxonomyVersion: '4.1',
  questions: allQuestions
};